import { createSelector } from '@ngrx/store';
import { selectCaseState } from './common-case.selector';

export const selectServiceInformations = createSelector(
  selectCaseState,
  (state) => state.case.serviceInformations
);

